"use client";

import { c as _c } from "react/compiler-runtime";
import { MobileVotingModal, VotingModal } from "@/components/voting";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import React from "react";
interface WaveLeaderboardGridItemVotingModalProps {
  readonly drop: ExtendedDrop;
  readonly isOpen: boolean;
  readonly isMobileScreen: boolean;
  readonly onClose: () => void;
}
export const WaveLeaderboardGridItemVotingModal: React.FC<WaveLeaderboardGridItemVotingModalProps> = t0 => {
  const $ = _c(5);
  const {
    drop,
    isOpen,
    isMobileScreen,
    onClose
  } = t0;
  let t1;
  if ($[0] !== drop || $[1] !== isMobileScreen || $[2] !== isOpen || $[3] !== onClose) {
    t1 = isMobileScreen ? <MobileVotingModal drop={drop} isOpen={isOpen} onClose={onClose} /> : <VotingModal drop={drop} isOpen={isOpen} onClose={onClose} />;
    $[0] = drop;
    $[1] = isMobileScreen;
    $[2] = isOpen;
    $[3] = onClose;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};